module.exports = "/src/views/games/other/images/maps/map_1.png";